import { useEffect, useState, FC } from "react";
import { Formik, Form } from "formik";
import {
  SelectChangeEvent,
  Button,
  Grid,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";
import Box from "@mui/material/Box";
import { DataField, Picker } from "../../atoms";
import ConnectionS3Bucket from "../../molecules/connectionTypes/ConnectionS3Bucket";
import ConnectionWindowsFileshare from "../../molecules/connectionTypes/ConnectionWindowsFileshare";
import ConnectionDatabase from "../../molecules/connectionTypes/ConnectionDatabase";
import * as functions from "../../shared/functions";
import { LoadingButton } from "@mui/lab";
import SaveIcon from "@mui/icons-material/Save";
import { IFormField } from "../../shared/globalTypes";
import Back from "../../atoms/backButton";
import * as constants from "../../../constants/_pickerValues";
import Skeleton from "@mui/material/Skeleton";
import { useDispatch, useSelector } from "react-redux";
import SchemaSelection from "../schemaSelection/SchemaSelection";
import * as actions from "../../../store/dataSource/actions";
import { IAccessControl, IDataSourceDetails } from "../../../store/dataSource/types";
import { IUser } from "../../../store/groups/types";
import {
  getAccessControlSelector,
  postDataSelector,
  getStewardSelector,
  getSourceSelector,
  getSourcePendingSelector,
  postConnectionSelector,
  postConnectionPendingSelector,
  postDataPendingSelector,
  getStewardPendingSelector, getAccessControlPendingSelector,
} from "../../../store/dataSource/selectors";
import {
  getProfileDataSelector,
  getRoleClaimsSelector,
} from "../../../store/auth/selectors";
import { getGroupPendingSelector, getGroupUsersSelector } from "../../../store/groups/selectors";
import { fetchGroupUsersRequest } from "../../../store/groups/actions"
import React from "react";
import { useParams } from "react-router";
import { fetchSourceDetailsReq } from "../../../store/dataSource/actions";
import { useNavigate } from "react-router-dom";
import { fetchSpokesRequest } from "../../../store/spokes/actions";
import { fetchSpokeSelector } from "../../../store/spokes/selectors";
import { ISpokeDetails, ISpokeSearchParams } from "../../../store/spokes/types";
import ConnectionAzure from "../../molecules/connectionTypes/ConnectionAzure";
import { convertUTCDateToLocalDate } from '../../shared/functions';
import { getProfileSelector } from "../../../store/userProfile/selectors";
import { IProfile } from "../../../store/userProfile/types";
import { IDP_USERS_PRODUCTION } from "../../../constants/common";
import ConnectionFoundry from "../../molecules/connectionTypes/ConnectionFoundry";
import FoundrySelection from "../schemaSelection/FoundrySelection";

// Form fields object

export interface IDataSourceFields {
  name: IFormField;
  description: IFormField;
  owner: IFormField;
  accessControls: IFormField;
  dataStewards: IFormField;
  securityClassification: IFormField;
  privacyClassification: IFormField;
  rttmsCi: IFormField;
  secretName: IFormField;
  endpoint: IFormField;
  database: IFormField;
  extractSource: IFormField;
  port: IFormField;
  instanceName: IFormField;
  username: IFormField;
  password: IFormField;
  serviceName: IFormField;
  s3Bucket: IFormField;
  s3Path: IFormField;
  shareName: IFormField;
  winPath: IFormField;
  winUsername: IFormField;
  winPassword: IFormField;
  sourceID: IFormField;
  accountName: IFormField;
  container: IFormField;
  pathPrefix: IFormField;
  sasToken: IFormField;
  accountKey: IFormField;
  spoke: IFormField;
  hostName: IFormField;
  accessToken: IFormField;
  datasetRID: IFormField;
}

// Instantiating Data Source's initial state

let DataSourceInitialState: IDataSourceFields = {
  name: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  sourceID: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  description: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  owner: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  accessControls: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  dataStewards: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  securityClassification: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  privacyClassification: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  rttmsCi: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  secretName: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  s3Bucket: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  s3Path: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  endpoint: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  database: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  extractSource: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  port: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  instanceName: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  username: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  password: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  serviceName: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  shareName: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  winPath: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  winPassword: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  winUsername: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  accountName: {
    fieldValue: "",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  container: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  pathPrefix: {
    fieldValue: "/Realm",
    isError: false,
    errorMsg: "",
    isNumber: false,
  },
  sasToken: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  accountKey: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  spoke: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  hostName: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  accessToken: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
  datasetRID: { fieldValue: "", isError: false, errorMsg: "", isNumber: false },
};

let DataStewardIDsInitial: IUser[] = [];
let AccessControlsInitial: string[] = [constants.IDP_PROD_USERS];

// mode for determining if form is for add, edit or view

interface Props {
  mode?: string;
}

export const DataSourceForm: FC<Props> = ({
  mode = constants.MODE.add,
}: Props) => {
  const dispatch = useDispatch();

  const accessControls = useSelector(getAccessControlSelector);
  const accessControlsPending = useSelector(getAccessControlPendingSelector);
  const postDataSource = useSelector(postDataSelector);
  const postDataSourcePending = useSelector(postDataPendingSelector);
  const userProfile = useSelector(getProfileDataSelector);
  const idpUsersProduction = useSelector(getGroupUsersSelector(IDP_USERS_PRODUCTION)).sort((a, b) => a.userName.toLowerCase().localeCompare(b.userName.toLowerCase()));
  const idpUsersProductionPending = useSelector(getGroupPendingSelector(IDP_USERS_PRODUCTION));
  const spokesData = useSelector(fetchSpokeSelector);
  const stewardData = useSelector(getStewardSelector).sort((a, b) => a.userName.toLowerCase().localeCompare(b.userName.toLowerCase()));
  const stewardDataPending = useSelector(getStewardPendingSelector);
  const getDataSource = useSelector(getSourceSelector);
  const loadingDataSource = useSelector(getSourcePendingSelector);
  const postConnection = useSelector(postConnectionSelector);
  const postConnectionPending = useSelector(postConnectionPendingSelector);
  const roles = useSelector(getRoleClaimsSelector); // roles  - IDP.Admin or IDP.User
  const [showGroupError, setShowGroupError] = useState(false);
  const [formMode, setFormMode] = useState(mode);

  const [dataSourceFormData, setDataSourceFormData] = useState(
    DataSourceInitialState
  );
  const [dataStewardIDs, setDataStewardIDs] = useState(DataStewardIDsInitial);
  const [connection, setConnection] = useState("");
  const [spokeType, setSpokeType] = useState("");
  const [connectionDetailsValue, setConnectionDetailsValue] = useState("");
  const [connectionSuccess, setConnectionSuccess] = useState(false);
  const [displaySaveBtn, setDisplaySaveBtn] = useState(false);
  const [displaySchemaBtn, setDisplaySchemaBtn] = useState(false);
  const [displayFoundrySelection, setDisplayFoundrySelection] = useState(false);
  const [displayExtractorBtn, setDisplayExtractorBtn] = useState(false);
  const [displayCustomSQLBtn, setDisplayCustomSQLBtn] = useState(false);
  const [displayEditBtn, setDisplayEditBtn] = useState(false);
  const [displayTestBtn, setDisplayTestBtn] = useState(true);
  const [disablePrivacy, setDisablePrivacy] = useState(false);
  const [validationErrors, setValidationErrors] = useState(false);
  const [secretNameValue, setSecretNameValue] = useState("");
  const [accessControlGroup, setAccessControlGroup] = useState<Array<string>>(
    AccessControlsInitial
  );
  const [dataStewardGroup, setDataStewardGroup] = useState("");
  const [ownerValue, setOwnerValue] = useState("");
  const [loadIcon, setLoadIcon] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [createdBy, setCreatedBy] = useState("");
  const [createdOn, setCreatedOn] = useState("");
  const [lastUpdatedBy, setLastUpdatedBy] = useState("");
  const [lastUpdatedOn, setLastUpdatedOn] = useState("");

  //View mode connection details fields
  const [database, setDatabase] = useState<any>()
  const [endpoint, setEndpoint] = useState<any>()
  const [port, setPort] = useState<any>()
  const [username, setUsername] = useState<any>()
  const [bucket, setBucket] = useState<any>()
  const [path, setPath] = useState<any>()
  const [shareName, setShareName] = useState<any>()
  const [adlsPathPrefix, setADLSPathPrefix] = useState("");

  //Foundry
  const [hostName, setHostName] = useState("");

  const navigate = useNavigate();

  const { sourceId } = useParams();

  const params: ISpokeSearchParams = {
    // skip: page * rowsPerPage,
    // top: rowsPerPage,
    // count: true,
    // search: searchTerm,
    // name: name,
    // owner: owner,
    count: true,
    top: 10,
    skip: 0,
    name: [],
    owner: [],
  };

  // Populate owners, access controls and data stewards

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!idpUsersProductionPending && idpUsersProduction.length <= 0) {
      dispatch(fetchGroupUsersRequest(IDP_USERS_PRODUCTION));
    }
    // dispatch(actions.fetchStewardRequest("IDP Users Production"));
    if (!accessControlsPending && accessControls.length <= 0) {
      dispatch(actions.fetchAccessControlRequest());
    }
    dispatch(fetchSpokesRequest(params));
    setDisplayExtractorBtn(false);
    setDisplaySchemaBtn(false);
    setDisplayCustomSQLBtn(false);
    setDisplayTestBtn(false);
    setDisplaySaveBtn(false);
    resetFields();
  }, []);

  useEffect(() => {
    if (dataStewardGroup) {
      dispatch(actions.fetchStewardRequest(dataStewardGroup));
    }
  }, [dataStewardGroup]);

  // reset fields
  const resetFields = () => {
    if (dataSourceFormData.name.fieldValue === "")
      dataSourceFormData.name.isError = false;
    if (dataSourceFormData.description.fieldValue === "")
      dataSourceFormData.description.isError = false;
    if (dataSourceFormData.owner.fieldValue === "")
      dataSourceFormData.owner.isError = false;
    dataSourceFormData.dataStewards.isError =
      dataStewardIDs && dataStewardIDs.length !== 0 ? true : false;

    if (
      connection === constants.CONNECTION_TYPES.mssql ||
      connection === constants.CONNECTION_TYPES.oracle ||
      connection === constants.CONNECTION_TYPES.postGres
    ) {
      if (connection === constants.CONNECTION_TYPES.mssql) {
        if (dataSourceFormData.database.fieldValue === "")
          dataSourceFormData.database.isError = false;
        // if (dataSourceFormData.instanceName.fieldValue === "")
        //   dataSourceFormData.instanceName.isError = false;
        if (dataSourceFormData.port.fieldValue === "")
          dataSourceFormData.port.isError = false;
        if (dataSourceFormData.password.fieldValue === "")
          dataSourceFormData.password.isError = false;
      } else if (connection === constants.CONNECTION_TYPES.oracle) {
        if (dataSourceFormData.extractSource.fieldValue === "")
          dataSourceFormData.extractSource.isError = false;
        if (dataSourceFormData.database.fieldValue === "")
          dataSourceFormData.database.isError = false;
        if (dataSourceFormData.serviceName.fieldValue === "")
          dataSourceFormData.serviceName.isError = false;
        if (dataSourceFormData.port.fieldValue === "")
          dataSourceFormData.port.isError = false;
        if (dataSourceFormData.password.fieldValue === "")
          dataSourceFormData.password.isError = false;
      } else if (connection === constants.CONNECTION_TYPES.postGres) {
        if (dataSourceFormData.port.fieldValue === "")
          dataSourceFormData.port.isError = false;
        if (dataSourceFormData.password.fieldValue === "")
          dataSourceFormData.password.isError = false;
      } else {
        if (dataSourceFormData.database.fieldValue === "")
          dataSourceFormData.database.isError = false;
      }

      if (dataSourceFormData.endpoint.fieldValue === "")
        dataSourceFormData.endpoint.isError = false;
      if (dataSourceFormData.username.fieldValue === "")
        dataSourceFormData.username.isError = false;
    }

    if (connection === constants.CONNECTION_TYPES.s3Buckets) {
      if (dataSourceFormData.s3Bucket.fieldValue === "")
        dataSourceFormData.s3Bucket.isError = false;
      if (dataSourceFormData.s3Path.fieldValue === "")
        dataSourceFormData.s3Path.isError = false;
    }

    if (connection === constants.CONNECTION_TYPES.windowsFileshare) {
      if (dataSourceFormData.shareName.fieldValue === "")
        dataSourceFormData.shareName.isError = false;
      if (dataSourceFormData.winPath.fieldValue === "")
        dataSourceFormData.winPath.isError = false;
      if (dataSourceFormData.winUsername.fieldValue === "")
        dataSourceFormData.winUsername.isError = false;
      if (dataSourceFormData.winPassword.fieldValue === "")
        dataSourceFormData.winPassword.isError = false;
    }
    if (connection === constants.CONNECTION_TYPES.azure) {
      if (dataSourceFormData.accountName.fieldValue === "")
        dataSourceFormData.accountName.isError = false;
      if (dataSourceFormData.container.fieldValue === "")
        dataSourceFormData.container.isError = false;
      if (dataSourceFormData.pathPrefix.fieldValue === "")
        dataSourceFormData.pathPrefix.isError = false;
      if (dataSourceFormData.sasToken.fieldValue === "")
        dataSourceFormData.sasToken.isError = false;
      if (dataSourceFormData.accountKey.fieldValue === "")
        dataSourceFormData.accountKey.isError = false;
    }
    setDataSourceFormData(dataSourceFormData);
  };
  // Handling owner changes

  useEffect(() => {
    dataSourceFormData.owner.fieldValue = ownerValue;
    setDataSourceFormData(dataSourceFormData);
    //Sort Data Stewards Group
    accessControls.sort((a, b) => a.groupName.toLowerCase().localeCompare(b.groupName.toLowerCase()));
  }, [ownerValue]);

  useEffect(() => {
    if (userProfile) {
      setOwnerValue(userProfile["userPrincipalName"]);
    }
  }, [userProfile]);

  useEffect(() => {
    if (roles && roles.length > 0) {
      setIsAdmin(roles.includes("IDP.Admin") ? true : false);
    }
  }, [roles]);

  // Populate names for stewards based on selected data steward AD group


  // GET source details, depending on source ID (when it is either VIEW or EDIT)

  useEffect(() => {
    setDisplaySaveBtn(false);
    setDisplayEditBtn(false);

    // When source ID is available, when it is either VIEW or EDIT

    if (mode !== constants.MODE.add && sourceId) {
      dispatch(fetchSourceDetailsReq(Number(sourceId)));
      if (mode === constants.MODE.edit) {
        setDisplaySaveBtn(true);
        setFormMode(mode);
      }

      if (
        mode === constants.MODE.view &&
        (isAdmin === true ||
          dataSourceFormData.owner.fieldValue === userProfile?.mail)
      )
        setDisplayEditBtn(true);
      setFormMode(mode);
    }
  }, [sourceId, mode]);

  useEffect(() => {
    if (mode === constants.MODE.view && isAdmin === true)
      setDisplayEditBtn(true);
  }, [isAdmin]);

  // Update dataSourceFormData state

  function getSpokeName(dataSource: IDataSourceDetails) {
    const spokeId: number = dataSource.spokeId !== null ? dataSource.spokeId : 0;
    // Fetch spoke name
    const fetchSpoke: ISpokeDetails[] = spokesData?.length !== undefined
      ? spokesData.filter((x) => x.spokeId === spokeId)
      : []
    return fetchSpoke[0]?.name ? fetchSpoke[0].name : "HUB"
  }

  useEffect(() => {
    if (mode === constants.MODE.view && getDataSource) {
      dataSourceFormData.name.fieldValue = getDataSource["name"];
      dataSourceFormData.sourceID.fieldValue =
        getDataSource["sourceId"].toString();
      dataSourceFormData.description.fieldValue =
        getDataSource["business"].description;
      dataSourceFormData.owner.fieldValue = getDataSource["business"].owner
        ? getDataSource["business"].owner
        : " ";
      dataSourceFormData.accessControls.fieldValue = getDataSource[
        "governance"
      ].accessControl.toString()
        ? getDataSource["governance"].accessControl.toString()
        : " ";
      setAccessControlGroup(getDataSource["governance"].accessControl);
      dataSourceFormData.dataStewards.fieldValue =
        getDataSource["business"].dataStewards;
      dataSourceFormData.securityClassification.fieldValue = getDataSource[
        "governance"
      ].securityClassification
        ? getDataSource["governance"].securityClassification
        : " ";
      dataSourceFormData.privacyClassification.fieldValue = getDataSource[
        "governance"
      ].privacyClassification
        ? getDataSource["governance"].privacyClassification
        : " ";
      dataSourceFormData.rttmsCi.fieldValue = getDataSource["business"].rttmsCI
        ? getDataSource["business"].rttmsCI
        : " ";
      dataSourceFormData.secretName.fieldValue = getDataSource["secretName"];
      dataSourceFormData.spoke.fieldValue = getSpokeName(getDataSource);

      setLastUpdatedBy(getDataSource.updatedBy);
      setLastUpdatedOn(convertUTCDateToLocalDate(getDataSource.updatedOn).toString());
      setCreatedOn(convertUTCDateToLocalDate(getDataSource.createdOn).toString());
      setCreatedBy(getDataSource.createdBy);
      setDataSourceFormData(dataSourceFormData);
      setConnectionDetailsValue(getDataSource["connectionDetails"]);
      const getString = getDataSource["connectionDetails"] && getDataSource["connectionDetails"].replaceAll(`'`, `"`)
      if (getDataSource["layerType"] !== constants.EXTRACT_TYPES.foundry) {
        try {
          const secondToLast = getString && getString[getString.length - 2];
          let jsonString;
          //cleaning unwanted commas
          if (secondToLast === ",") {
            jsonString = (getString.replace(/[,].$/, "}"))

          }
          else {
            jsonString = getString
          }
          const convertConnectionDetails = JSON.parse(jsonString)

          convertConnectionDetails && Object.entries(convertConnectionDetails).forEach(([key, value]) => {
            if (key === "database") {
              setDatabase(value)
            }
            if (key === "port") {
              setPort(value)
            }
            if (key === "userName") {
              setUsername(value)
            }
            if (key === "endpoint") {
              setEndpoint(value)
            }
            if (key === "bucket") {
              setBucket(value)
            }
            if (key === "path") {
              setPath(value)
            }
            if (key === "shareName") {
              setShareName(value)
            }
          })
        } catch (error) {
          console.log("Could not parse connection details")
        }
      }
      else {
        const startIndex = getDataSource["connectionDetails"].indexOf("https://");
        const endIndex = getDataSource["connectionDetails"].indexOf("?");

        if (startIndex !== -1 && endIndex !== -1) {
          const host = getDataSource["connectionDetails"].substring(startIndex, endIndex);
          setHostName(host);
        }
      }

      setDisablePrivacy(true)
      setConnection(
        functions.generateConnectionType(getDataSource["layerType"])
      );
      setDataStewardIDs(
        functions.getStewardIDs(getDataSource["business"].dataStewards)
      );

      // if mode is view and layer type is non-SQL
      if (
        mode === constants.MODE.view &&
        (getDataSource["layerType"] === constants.EXTRACT_TYPES.s3Buckets ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.windowsFileshare ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.fileSystem ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.azure ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.adls
        )
      ) {
        if (getDataSource["layerType"] === "EXTRACT_ADLS") {
          var value = getDataSource["connectionDetails"];
          setADLSPathPrefix(value.substring(
            value.indexOf("Path=") + 5, value.indexOf(";AccountKey")));
        }
        setDisplayExtractorBtn(true);
        setDisplaySchemaBtn(false);
        setDisplayCustomSQLBtn(false);
      }

      if (
        mode === constants.MODE.view &&
        (getDataSource["layerType"] === constants.EXTRACT_TYPES.oracle ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.mssql ||
          getDataSource["layerType"] === constants.EXTRACT_TYPES.postGres
        )
      ) {
        setDisplayExtractorBtn(false);
        setDisplaySchemaBtn(true);
        setDisplayCustomSQLBtn(true);
      }

      if (mode === constants.MODE.view && getDataSource["layerType"] === constants.EXTRACT_TYPES.foundry) {
        setDisplayFoundrySelection(true);
        setDisplayExtractorBtn(false);
      }
    } else if (mode === constants.MODE.edit && getDataSource) {
      dataSourceFormData.name.fieldValue = getDataSource["name"];
      dataSourceFormData.sourceID.fieldValue =
        getDataSource["sourceId"].toString();
      dataSourceFormData.description.fieldValue =
        getDataSource["business"].description;
      dataSourceFormData.owner.fieldValue = getDataSource["business"].owner;
      dataSourceFormData.accessControls.fieldValue =
        getDataSource["governance"].accessControl.toString();
      dataSourceFormData.dataStewards.fieldValue =
        getDataSource["business"].dataStewards;
      dataSourceFormData.securityClassification.fieldValue =
        getDataSource["governance"].securityClassification;
      dataSourceFormData.privacyClassification.fieldValue =
        getDataSource["governance"].privacyClassification;
      dataSourceFormData.rttmsCi.fieldValue = getDataSource["business"].rttmsCI;
      dataSourceFormData.secretName.fieldValue = getDataSource["secretName"];
      dataSourceFormData.spoke.fieldValue = getSpokeName(getDataSource);
      setDataSourceFormData(dataSourceFormData);
      setConnectionDetailsValue(getDataSource["connectionDetails"]);
      setConnection(
        functions.generateConnectionType(getDataSource["layerType"])
      );
      setDataStewardIDs(
        functions.getStewardIDs(getDataSource["business"].dataStewards)
      );
      setShowGroupError(false);
      setDisablePrivacy(true)

      if (getDataSource["layerType"] === "EXTRACT_ADLS") {
        var value = getDataSource["connectionDetails"];
        setADLSPathPrefix(value.substring(
          value.indexOf("Path=") + 5, value.indexOf(";AccountKey")));
      }
    } else {
      dataSourceFormData.name.fieldValue = "";
      dataSourceFormData.description.fieldValue = "";
      dataSourceFormData.owner.fieldValue = "";
      dataSourceFormData.accessControls.fieldValue = "";
      dataSourceFormData.dataStewards.fieldValue = "";
      dataSourceFormData.securityClassification.fieldValue = "general";
      dataSourceFormData.privacyClassification.fieldValue = "none";
      dataSourceFormData.rttmsCi.fieldValue = "";
      dataSourceFormData.secretName.fieldValue = "";
      setDataSourceFormData(dataSourceFormData);
    }

  }, [getDataSource, mode]);

  // Hide/display buttons if there is a data source in the store, or if mode has changed

  useEffect(() => {
    if (postDataSource && displaySaveBtn === true && mode === constants.MODE.add) {
      toggleButtons();

      // Fetch spoke name
      const spokeId: number = Number(dataSourceFormData.spoke.fieldValue);
      const fetchSpoke: ISpokeDetails[] = spokesData.length !== undefined
        ? spokesData.filter((x) => x.spokeId === spokeId)
        : []
      dataSourceFormData.spoke.fieldValue = fetchSpoke[0]?.name ? fetchSpoke[0].name : "HUB"


      setConnectionDetailsOnView();
      setFormMode(constants.MODE.view);
    } else {
      setDisplaySchemaBtn(false);
      setDisplayCustomSQLBtn(false);
      setDisplayExtractorBtn(false);
      if (mode === constants.MODE.add) setDisplaySaveBtn(false);
    }
  }, [postDataSource, mode]);

  useEffect(() => {
    if (
      mode !== constants.MODE.view &&
      (connection === constants.CONNECTION_TYPES.s3Buckets ||
        connection === constants.CONNECTION_TYPES.windowsFileshare ||
        connection === constants.CONNECTION_TYPES.foundry ||
        connection === constants.CONNECTION_TYPES.azure)
    ) {
      setDisplaySaveBtn(true);
      setConnectionSuccess(true);
    }

    if (
      mode === constants.MODE.add &&
      connection !== "" &&
      connection !== constants.CONNECTION_TYPES.s3Buckets &&
      connection !== constants.CONNECTION_TYPES.windowsFileshare &&
      connection !== constants.CONNECTION_TYPES.foundry &&
      connection !== constants.CONNECTION_TYPES.azure

    ) {
      setDisplayTestBtn(true);
    }
  }, [connection]);

  useEffect(() => {
    if (postConnection?.succeeded === true) {
      setConnectionDetails(connection);
      setDisplayExtractorBtn(false);
      setDisplaySchemaBtn(false);
      setDisplayCustomSQLBtn(false);
      setDisplaySaveBtn(true);
      setConnectionSuccess(true);
    }
  }, [postConnection]);

  useEffect(() => {
    if (validationErrors === false) {
      if (
        connection !== constants.CONNECTION_TYPES.s3Buckets &&
        connection !== constants.CONNECTION_TYPES.windowsFileshare &&
        connection !== constants.CONNECTION_TYPES.azure &&
        connectionSuccess !== false
      ) {
        checkConnection();
      }

      if (connectionSuccess === true) {
        if (mode === constants.MODE.add) {
          dispatch(actions.postDataSourceRequest(getPayload()));
        } else {
          dispatch(
            actions.putDataSourceRequest(Number(sourceId), getPayload())
          );
        }
      }
    }
  }, [validationErrors]);

  const toggleButtons = () => {
    if (
      (connection === constants.CONNECTION_TYPES.oracle ||
        connection === constants.CONNECTION_TYPES.postGres ||
        connection === constants.CONNECTION_TYPES.mssql) &&
      connection !== constants.CONNECTION_TYPES.foundry
    ) {
      setDisplaySchemaBtn(true);
      setDisplayCustomSQLBtn(true);
      setDisplayExtractorBtn(false);
    } else if (connection !== constants.CONNECTION_TYPES.foundry) {
      setDisplaySchemaBtn(false);
      setDisplayExtractorBtn(true);
      setDisplayCustomSQLBtn(false);
    }
    else if (connection === constants.CONNECTION_TYPES.foundry) {
      setDisplayFoundrySelection(true);
    }

    setDisplaySaveBtn(false);
    setDisplayTestBtn(false);
  };

  const setConnectionDetailsOnView = () => {
    try {
      let jsonString = connectionDetailsValue.replaceAll(`'`, `"`)

      const convertConnectionDetails = JSON.parse(jsonString)
      convertConnectionDetails && Object.entries(convertConnectionDetails).forEach(([key, value]) => {
        if (key === "database") {
          setDatabase(value)
        }
        if (key === "port") {
          setPort(value)
        }
        if (key === "userName") {
          setUsername(value)
        }
        if (key === "endpoint") {
          setEndpoint(value)
        }
        if (key === "bucket") {
          setBucket(value)
        }
        if (key === "path") {
          setPath(value)
        }
        if (key === "shareName") {
          setShareName(value)
        }
      })
    } catch (error) {
    }
  };

  const goBack = () => {
    resetFields();
    window.history.back();
  };


  //    ************ spoke based access controls ****************

  const uProfile: IProfile[] = useSelector(getProfileSelector);

  const [spokeProfile, setSpokeProfile] = useState<any>();
  const [spokeList, setSpokeList] = useState<any>();

  useEffect(() => {
    if (uProfile && uProfile.length > 0) {
      setSpokeProfile(uProfile);
    }
  }, [uProfile]);

  useEffect(() => {
    if (spokesData && spokesData.length > 0) {
      setSpokeList(spokesData);
    }
    if ([constants.MODE.view, constants.MODE.edit].indexOf(mode) > -1 && getDataSource) {
      dataSourceFormData.spoke.fieldValue = getSpokeName(getDataSource)
    }
  }, [spokesData]);


  let spoke: ISpokeDetails[];
  const checkAdmin = () => {

    // filter spoke list based on row spoke name: returns single spoke
    if (spokeList) {
      spoke = spokeList.filter((x: any) => x.name === dataSourceFormData.spoke.fieldValue)

    }


    // check if spoke exists in the users profile
    let x;
    if (spoke && spoke.length > 0 && spokeProfile) {
      x = spokeProfile.filter((x: any) => x.adGroupName === spoke[0].adminGroupName)

    }

    // if the spoke admin group name matches user's group name ==> user is spoke admin
    if (x && x.length > 0) return true
    else if (isAdmin) return true
    else return false

  }

  //    ************ end spoke based access controls ****************

  const viewExtractors = (event: React.MouseEvent<HTMLButtonElement>) => {
    const url = `/DataExtractorList/${dataSourceFormData.name.fieldValue}`;
    if (event.ctrlKey) {
      window.open(url, '_blank')
    }
    else {
      navigate(url);
    }
  };

  // Update state's dropdown values

  const updateDropdown = (event: SelectChangeEvent<string>) => {
    let value: string = event.target.value;

    if (event.target.name === "securityClassification") {
      if (value !== "confidential") {
        setDisablePrivacy(false);
      } else {
        setDisablePrivacy(true);
      }
    }

    setDataSourceFormData({
      ...dataSourceFormData,
      [event.target.name]: functions.getFormField(value),
    });
  };

  // Update data steward group

  const updateDataStewardGroup = (event: SelectChangeEvent<string>) => {
    let value: string = event.target.value;
    setDataStewardGroup(value);
    setShowGroupError(false);
  };

  // Hide "save", "select tables" and "select schemas" buttons when connection type is changed

  const changeConnection = (event: SelectChangeEvent<string>) => {
    let connectionType: string = event.target.value;

    setConnection(connectionType);
    setDisplayTestBtn(false);

    setDisplayExtractorBtn(false);
    setDisplaySchemaBtn(false);
    setDisplaySaveBtn(false);
  };

  const changeSpokes = (event: SelectChangeEvent<string>) => {
    let spokeType: string = event.target.value;

    setSpokeType(spokeType);
  };

  // Update fieldValue when it is changed; needed to update the UI of the text fields, text areas
  // Clean value if the field changed is data source

  const handleChange = (event: {}) => {
    const e = event as React.ChangeEvent<HTMLInputElement>;

    setDataSourceFormData({
      ...dataSourceFormData,
      [e.target.name]:
        e.target.name === "name"
          ? functions.getFormField(
            functions.cleanName(e.currentTarget.value, "")
          )
          : functions.getFormField(e.currentTarget.value),
    });

  };

  const handleDropdownChange = (e: SelectChangeEvent<string>) => {
    setDataSourceFormData({
      ...dataSourceFormData,
      [e.target.name]: functions.getFormField(e.target.value),
    });
  };

  // Test the connection, validates the required fields prior to testing

  const testConnection = () => {
    setDisplayExtractorBtn(false);
    setDisplaySchemaBtn(false);
    setDisplayCustomSQLBtn(false);

    validate();
  };

  // Validate the required fields of the form
  // onBlur won't be able to determine if fields are empty unless the focus was on a field
  // Conditions are set on which to validate, depending on the connection type
  // Secret name to be generated each time a form is validated, as secret name is also a required field but is read-only

  const validate = () => {
    // check if connection is mssql, postgres, oracle
    // if fields are empty, then display alert and validation
    // else move to check connection
    if (
      connection === constants.CONNECTION_TYPES.mssql ||
      connection === constants.CONNECTION_TYPES.oracle ||
      connection === constants.CONNECTION_TYPES.postGres
    ) {
      setSecretName(connection);
      if (
        dataSourceFormData.name.fieldValue === "" ||
        dataSourceFormData.description.fieldValue === "" ||
        dataSourceFormData.owner.fieldValue === "" ||
        dataSourceFormData.database.fieldValue === "" ||
        dataSourceFormData.port.fieldValue === "" ||
        dataSourceFormData.username.fieldValue === "" ||
        dataSourceFormData.password.fieldValue === "" ||
        dataStewardGroup === "" ||
        dataStewardIDs === undefined
      ) {
        if (dataSourceFormData.name.fieldValue === "")
          dataSourceFormData.name.isError = true;
        if (dataSourceFormData.description.fieldValue === "")
          dataSourceFormData.description.isError = true;
        if (dataSourceFormData.owner.fieldValue === "")
          dataSourceFormData.owner.isError = true;
        dataSourceFormData.dataStewards.isError =
          dataStewardIDs && dataStewardIDs.length !== 0 ? false : true;
        if (dataStewardGroup === "") {
          setShowGroupError(true);
        }
        if (connection === constants.CONNECTION_TYPES.mssql) {
          if (dataSourceFormData.database.fieldValue === "")
            dataSourceFormData.database.isError = true;
          // if (dataSourceFormData.instanceName.fieldValue === "")
          //   dataSourceFormData.instanceName.isError = true;
          if (dataSourceFormData.port.fieldValue === "")
            dataSourceFormData.port.isError = true;
          if (dataSourceFormData.password.fieldValue === "")
            dataSourceFormData.password.isError = true;
        } else if (connection === constants.CONNECTION_TYPES.oracle) {
          if (dataSourceFormData.extractSource.fieldValue === "")
            dataSourceFormData.extractSource.isError = true;
          if (dataSourceFormData.database.fieldValue === "")
            dataSourceFormData.database.isError = true;
          if (dataSourceFormData.serviceName.fieldValue === "")
            dataSourceFormData.serviceName.isError = true;
          if (dataSourceFormData.port.fieldValue === "")
            dataSourceFormData.port.isError = true;
          if (dataSourceFormData.password.fieldValue === "")
            dataSourceFormData.password.isError = true;
        } else if (connection === constants.CONNECTION_TYPES.postGres) {
          if (dataSourceFormData.port.fieldValue === "")
            dataSourceFormData.port.isError = true;
          if (dataSourceFormData.password.fieldValue === "")
            dataSourceFormData.password.isError = true;
        } else {
          if (dataSourceFormData.database.fieldValue === "")
            dataSourceFormData.database.isError = true;
        }

        if (dataSourceFormData.endpoint.fieldValue === "")
          dataSourceFormData.endpoint.isError = true;
        if (dataSourceFormData.username.fieldValue === "")
          dataSourceFormData.username.isError = true;
        alert("Required fields cannot be empty");
        setDataSourceFormData(dataSourceFormData);
        setValidationErrors(true);
      } else {
        setValidationErrors(false);
        checkConnection();
      }
    } else {
      // if fields are s3 Buckets, WFS or ADLS
      // check if fields are empty if yes the display validation
      // else dispatch source API

      // Amazon and mode is add
      if (
        connection === constants.CONNECTION_TYPES.s3Buckets &&
        mode === constants.MODE.add
      ) {
        setSecretName(connection);
        if (
          dataSourceFormData.s3Bucket.fieldValue === "" ||
          dataSourceFormData.s3Path.fieldValue === "" ||
          dataSourceFormData.name.fieldValue === "" ||
          dataSourceFormData.description.fieldValue === "" ||
          dataSourceFormData.owner.fieldValue === "" ||
          dataStewardGroup === "" ||
          dataStewardIDs === undefined
        ) {
          if (dataSourceFormData.s3Bucket.fieldValue === "")
            dataSourceFormData.s3Bucket.isError = true;
          if (dataSourceFormData.s3Path.fieldValue === "")
            dataSourceFormData.s3Path.isError = true;
          if (dataSourceFormData.name.fieldValue === "")
            dataSourceFormData.name.isError = true;
          if (dataSourceFormData.description.fieldValue === "")
            dataSourceFormData.description.isError = true;
          if (dataSourceFormData.owner.fieldValue === "")
            dataSourceFormData.owner.isError = true;
          dataSourceFormData.dataStewards.isError =
            dataStewardIDs && dataStewardIDs.length !== 0 ? false : true;
          if (dataStewardGroup === "") {
            setShowGroupError(true);
          }

          setDataSourceFormData(dataSourceFormData);
          alert("Required fields cannot be empty");
        } else {
          setValidationErrors(false);
          dispatch(actions.postDataSourceRequest(getPayload()));
        }
      }

      if (
        connection === constants.CONNECTION_TYPES.s3Buckets &&
        mode === constants.MODE.edit
      ) {
        dispatch(actions.putDataSourceRequest(Number(sourceId), getPayload()));
      }

      if (
        connection === constants.CONNECTION_TYPES.azure &&
        mode === constants.MODE.add
      ) {
        setSecretName(connection);
        if (
          dataSourceFormData.accountName.fieldValue === "" ||
          dataSourceFormData.container.fieldValue === "" ||
          dataSourceFormData.name.fieldValue === "" ||
          dataSourceFormData.description.fieldValue === "") {
          if (dataSourceFormData.name.fieldValue === "")
            dataSourceFormData.name.isError = true;
          if (dataSourceFormData.description.fieldValue === "")
            dataSourceFormData.description.isError = true;
          if (dataSourceFormData.owner.fieldValue === "")
            dataSourceFormData.owner.isError = true;
          if (dataSourceFormData.accountName.fieldValue === "")
            dataSourceFormData.accountName.isError = true;
          if (dataSourceFormData.container.fieldValue === "")
            dataSourceFormData.container.isError = true;
          if (
            dataSourceFormData.sasToken.fieldValue === "" &&
            dataSourceFormData.accountKey.fieldValue === ""
          ) {
            dataSourceFormData.sasToken.isError = true;
            dataSourceFormData.accountKey.isError = true;
          }
          setDataSourceFormData(dataSourceFormData);
          alert("Required fields cannot be empty");
        }
        else {
          setValidationErrors(false);
          dispatch(actions.postDataSourceRequest(getPayload()));
        }
      }

      if (
        connection === constants.CONNECTION_TYPES.azure &&
        mode === constants.MODE.edit
      ) {
        dispatch(actions.putDataSourceRequest(Number(sourceId), getPayload()));
      }

      // Windows File Share and mode is add
      if (
        connection === constants.CONNECTION_TYPES.windowsFileshare &&
        mode === constants.MODE.add
      ) {
        setSecretName(connection);
        if (
          dataSourceFormData.shareName.fieldValue === "" ||
          dataSourceFormData.winPath.fieldValue === "" ||
          dataSourceFormData.winUsername.fieldValue === "" ||
          dataSourceFormData.winPassword.fieldValue === "" ||
          dataSourceFormData.name.fieldValue === "" ||
          dataSourceFormData.description.fieldValue === "" ||
          dataSourceFormData.owner.fieldValue === "" ||
          dataStewardGroup === "" ||
          dataStewardIDs === undefined
        ) {
          if (dataSourceFormData.shareName.fieldValue === "")
            dataSourceFormData.shareName.isError = true;
          if (dataSourceFormData.winPath.fieldValue === "")
            dataSourceFormData.winPath.isError = true;
          if (dataSourceFormData.winUsername.fieldValue === "")
            dataSourceFormData.winUsername.isError = true;
          if (dataSourceFormData.winPassword.fieldValue === "")
            dataSourceFormData.winPassword.isError = true;
          if (dataSourceFormData.name.fieldValue === "")
            dataSourceFormData.name.isError = true;
          if (dataSourceFormData.description.fieldValue === "")
            dataSourceFormData.description.isError = true;
          if (dataSourceFormData.owner.fieldValue === "")
            dataSourceFormData.owner.isError = true;
          dataSourceFormData.dataStewards.isError =
            dataStewardIDs && dataStewardIDs.length !== 0 ? false : true;
          if (dataStewardGroup === "") {
            setShowGroupError(true);
          }

          setDataSourceFormData(dataSourceFormData);
          alert("WFS Required fields cannot be empty");
        } else {
          setValidationErrors(false);
          dispatch(actions.postDataSourceRequest(getPayload()));
        }

        if (
          connection === constants.CONNECTION_TYPES.s3Buckets &&
          mode === constants.MODE.edit
        ) {
          dispatch(
            actions.putDataSourceRequest(Number(sourceId), getPayload())
          );
        }
      }

      if (connection === constants.CONNECTION_TYPES.foundry && mode === constants.MODE.add) {
        setSecretName(connection);
        if (
          dataSourceFormData.hostName.fieldValue === "" ||
          dataSourceFormData.accessToken.fieldValue === "" ||
          dataSourceFormData.name.fieldValue === "" ||
          dataSourceFormData.description.fieldValue === "" ||
          dataSourceFormData.owner.fieldValue === "" ||
          dataStewardGroup === "" ||
          dataStewardIDs === undefined
        ) {
          if (dataSourceFormData.hostName.fieldValue === "")
            dataSourceFormData.hostName.isError = true;
          if (dataSourceFormData.accessToken.fieldValue === "")
            dataSourceFormData.accessToken.isError = true;

          if (dataSourceFormData.name.fieldValue === "")
            dataSourceFormData.name.isError = true;
          if (dataSourceFormData.description.fieldValue === "")
            dataSourceFormData.description.isError = true;
          if (dataSourceFormData.owner.fieldValue === "")
            dataSourceFormData.owner.isError = true;
          dataSourceFormData.dataStewards.isError =
            dataStewardIDs && dataStewardIDs.length !== 0 ? false : true;
          if (dataStewardGroup === "") {
            setShowGroupError(true);
          }

          setDataSourceFormData(dataSourceFormData);
          alert("Required fields cannot be empty");
        } else {
          setValidationErrors(false);
          dispatch(actions.postDataSourceRequest(getPayload()));
        }
      }
    }
  };

  // Check connection details if MSSQL, Oracle, Postgres
  const checkConnection = () => {
    dispatch(actions.postConnectionRequest(getConnectionPayload()));
    setConnectionSuccess(postConnection ? postConnection?.succeeded : false);
    setLoadIcon(true);
  };

  // Create or update a new data source
  // Called when the Save button is clicked

  function createNewDataSource() {

    if (mode === constants.MODE.add) {
      if (
        connection === constants.CONNECTION_TYPES.windowsFileshare ||
        connection === constants.CONNECTION_TYPES.s3Buckets ||
        connection === constants.CONNECTION_TYPES.azure ||
        connection === constants.CONNECTION_TYPES.foundry
      ) {
        setConnectionDetails(connection);
        validate();
      } else {
        setLoadIcon(true);
        dispatch(actions.postDataSourceRequest(getPayload()));
      }
    } else {
      dispatch(actions.putDataSourceRequest(Number(sourceId), getPayload()));
    }

  }

  // Generate the secret name

  const setSecretName = (connectionType: string) => {
    let secretName: string = "";

    switch (connection) {
      case constants.CONNECTION_TYPES.s3Buckets:
        secretName = functions.generateSecretNameS3(
          constants.SCREEN_TYPES.source,
          dataSourceFormData.s3Bucket.fieldValue,
          dataSourceFormData.s3Path.fieldValue
        );
        secretName = functions.generateSecretNameS3(
          constants.SCREEN_TYPES.source,
          dataSourceFormData.s3Bucket.fieldValue,
          dataSourceFormData.s3Path.fieldValue
        );
        break;
      case constants.CONNECTION_TYPES.windowsFileshare:
        secretName =
          "filesystem-source---" +
          functions.cleanName(dataSourceFormData.winPath.fieldValue);
        break;
      case constants.CONNECTION_TYPES.azure:
        secretName = functions.generateSecretNameADLS(
          dataSourceFormData.accountName.fieldValue,
          dataSourceFormData.container.fieldValue
        );
        break;
      case constants.CONNECTION_TYPES.foundry:
        secretName = functions.generateSecretNameFoundry(dataSourceFormData.hostName.fieldValue);
        break;
      default:
        secretName = functions.generateSecretName(
          connectionType,
          constants.SCREEN_TYPES.source,
          dataSourceFormData.endpoint.fieldValue,
          dataSourceFormData.database.fieldValue
        );
        break;
    }

    dataSourceFormData.secretName.fieldValue = secretName;

    setSecretNameValue(secretName);
    setDataSourceFormData(dataSourceFormData);
  };

  // Generate the connectionDetails string

  const setConnectionDetails = (connection: string) => {
    let connDetails: string = "";

    switch (connection) {
      case constants.CONNECTION_TYPES.mssql:
        connDetails =
          `{'endpoint':'${dataSourceFormData.endpoint.fieldValue}','database':'${dataSourceFormData.database.fieldValue}','port':'${dataSourceFormData.port.fieldValue}',` +
          `'userName':'${dataSourceFormData.username.fieldValue}'}`;

        break;

      case constants.CONNECTION_TYPES.oracle:
        connDetails =
          `{'endpoint':'${dataSourceFormData.endpoint.fieldValue}','database':'${dataSourceFormData.database.fieldValue}','extractSource':'${dataSourceFormData.extractSource.fieldValue}',` +
          `'port':'${dataSourceFormData.port.fieldValue}','userName':'${dataSourceFormData.username.fieldValue}','serviceName':'${dataSourceFormData.serviceName.fieldValue}',}`;

        break;

      case constants.CONNECTION_TYPES.s3Buckets:
        connDetails = `{'bucket':'${dataSourceFormData.s3Bucket.fieldValue}','path':'${dataSourceFormData.s3Path.fieldValue}'}`;

        break;

      case constants.CONNECTION_TYPES.windowsFileshare:
        connDetails = `{'shareName':'${dataSourceFormData.shareName.fieldValue}','path':'${dataSourceFormData.winPath.fieldValue}','userName':'${dataSourceFormData.winUsername.fieldValue}'}`;

        break;
      case constants.CONNECTION_TYPES.azure:
        connDetails =
          dataSourceFormData.accountKey.fieldValue !== ""
            ? `{'type':'AzureBlobStorage','appConnectionString':'','synapseConnectionString': AccountName=${dataSourceFormData.accountName.fieldValue};Container=${dataSourceFormData.container.fieldValue};Path=${("/UDL").concat(dataSourceFormData.name.fieldValue)};AccountKey=${dataSourceFormData.accountKey.fieldValue};`
            : `{'type':'AzureBlobStorage','appConnectionString':'','synapseConnectionString': AccountName=${dataSourceFormData.accountName.fieldValue};Container=${dataSourceFormData.container.fieldValue};Path=${("/UDL").concat(dataSourceFormData.name.fieldValue)};SASToken=${dataSourceFormData.sasToken.fieldValue};`;

        break;

      case constants.CONNECTION_TYPES.foundry:
        connDetails = `jdbc:foundrysql://${dataSourceFormData.hostName.fieldValue}?Password=${dataSourceFormData.accessToken.fieldValue}`;
        break;

      default:
        connDetails =
          `{'endpoint':'${dataSourceFormData.endpoint.fieldValue}','database':'${dataSourceFormData.database.fieldValue}',` +
          `'port':'${dataSourceFormData.port.fieldValue}','userName':'${dataSourceFormData.username.fieldValue}'}`;

        break;
    }

    setConnectionDetailsValue(connDetails);

    return connDetails;
  };

  // Setup payload for POST data source endpoint

  const getPayload = () => {
    dataSourceFormData.dataStewards.fieldValue =
      functions.getStewardsIDString(dataStewardIDs);
    dataSourceFormData.accessControls.fieldValue =
      accessControlGroup.toString();
    setDataSourceFormData(dataSourceFormData);

    if (mode === constants.MODE.add) {
      let payload = {
        name: dataSourceFormData.name.fieldValue,
        layerType: functions.generateLayerType(connection),
        connectionDetails:
          connectionDetailsValue !== ""
            ? connectionDetailsValue
            : setConnectionDetails(connection),
        connectionString: connection === constants.CONNECTION_TYPES.azure ? "https://" + dataSourceFormData.accountName.fieldValue + ".dfs.core.windows.net" : "",
        spokeId: parseInt(dataSourceFormData.spoke.fieldValue),
        secretName: dataSourceFormData.secretName.fieldValue,
        secrets: functions.generateSecretArray(
          connection,
          dataSourceFormData.secretName.fieldValue,
          dataSourceFormData.endpoint.fieldValue,
          dataSourceFormData.database.fieldValue,
          dataSourceFormData.port.fieldValue,
          dataSourceFormData.username.fieldValue,
          dataSourceFormData.password.fieldValue,
          dataSourceFormData.accountKey.fieldValue,
          dataSourceFormData.accountName.fieldValue,
          dataSourceFormData.container.fieldValue,
          dataSourceFormData.sasToken.fieldValue,
          dataSourceFormData.winPath.fieldValue,
          dataSourceFormData.shareName.fieldValue,
          dataSourceFormData.winUsername.fieldValue,
          dataSourceFormData.winPassword.fieldValue,
          dataSourceFormData.serviceName.fieldValue,
          dataSourceFormData.hostName.fieldValue,
          dataSourceFormData.accessToken.fieldValue
        ),
        business: {
          description: dataSourceFormData.description.fieldValue,
          owner: dataSourceFormData.owner.fieldValue,
          dataStewards: functions.getStewardsIDString(dataStewardIDs),
          rttmsCI: dataSourceFormData.rttmsCi.fieldValue,
        },
        governance: {
          securityClassification:
            dataSourceFormData.securityClassification.fieldValue,
          privacyClassification:
            dataSourceFormData.privacyClassification.fieldValue,
          accessControl: accessControlGroup,
        },
      };
      return payload;
    } else {
      let payload = {
        name: dataSourceFormData.name.fieldValue,
        layerType: functions.generateLayerType(connection),
        connectionDetails:
          connectionDetailsValue !== ""
            ? connectionDetailsValue === null
              ? "{}"
              : connectionDetailsValue
            : setConnectionDetails(connection),
        secretName: dataSourceFormData.secretName.fieldValue,
        business: {
          description: dataSourceFormData.description.fieldValue,
          owner: dataSourceFormData.owner.fieldValue,
          dataStewards: functions.getStewardsIDString(dataStewardIDs),
          rttmsCI: dataSourceFormData.rttmsCi.fieldValue,
        },
        governance: {
          securityClassification:
            dataSourceFormData.securityClassification.fieldValue,
          privacyClassification:
            dataSourceFormData.privacyClassification.fieldValue,
          accessControl: accessControlGroup,
        },
      };
      return payload;
    }
  };

  // Setup payload for POST test connection endpoint

  const getConnectionPayload = () => {
    let payload = {
      type: functions.generateTestConnectionType(connection),
      appConnectionString: functions.generateConnectionString(
        connection,
        constants.CONN_STRING_TYPE.app,
        dataSourceFormData.endpoint.fieldValue,
        dataSourceFormData.database.fieldValue,
        dataSourceFormData.port.fieldValue,
        dataSourceFormData.username.fieldValue,
        dataSourceFormData.password.fieldValue,
        dataSourceFormData.serviceName.fieldValue
      ),
      synapseConnectionString: functions.generateConnectionString(
        connection,
        constants.CONN_STRING_TYPE.synapse,
        dataSourceFormData.endpoint.fieldValue,
        dataSourceFormData.database.fieldValue,
        dataSourceFormData.port.fieldValue,
        dataSourceFormData.username.fieldValue,
        dataSourceFormData.password.fieldValue,
        dataSourceFormData.serviceName.fieldValue,
        dataSourceFormData.accountName.fieldValue,
        dataSourceFormData.pathPrefix.fieldValue,
        dataSourceFormData.container.fieldValue,
        dataSourceFormData.sasToken.fieldValue,
        dataSourceFormData.accountKey.fieldValue
      ),
    };

    return payload;
  };

  const editSource = (event: React.MouseEvent<HTMLButtonElement>) => {
    const url = `/EditDataSource/${sourceId}`;
    if (event.ctrlKey) {
      window.open(url, '_blank')
    }
    else {
      navigate(url);
    }
  };

  const configureTables = () => {
    const selectedTable = [dataSourceFormData.name.fieldValue];

    if (connection === "S3 Buckets") {

      navigate("/ConfigureTables", {
        state: {
          selectedTables: selectedTable,
          selectedSchema: null,
          dataSourceData: dataSourceFormData,
          accessControlGroup: accessControlGroup,
          dataStewardGroup: dataStewardGroup,
          dataStewardIDs: dataStewardIDs,
          connection: connection,
          endpoint: dataSourceFormData.s3Path.fieldValue,
          spokeName: dataSourceFormData.spoke.fieldValue
        },
      });
    }

    if (
      connection === constants.CONNECTION_TYPES.mssql ||
      connection === constants.CONNECTION_TYPES.oracle ||
      connection === constants.CONNECTION_TYPES.postGres
    ) {
      navigate("/ConfigureTables", {
        state: {
          selectedTables: selectedTable,
          selectedSchema: null,
          dataSourceData: dataSourceFormData,
          accessControlGroup: accessControlGroup,
          dataStewardGroup: dataStewardGroup,
          dataStewardIDs: dataStewardIDs,
          connection: connection,
          endpoint: "",
          customSQL: true,
          spokeName: dataSourceFormData.spoke.fieldValue
        },
      });
    }

    if (connection === "Windows Fileshare") {
      const selectedTable = [dataSourceFormData.name.fieldValue];
      navigate("/ConfigureTables", {
        state: {
          selectedTables: selectedTable,
          selectedSchema: null,
          dataSourceData: dataSourceFormData,
          accessControlGroup: accessControlGroup,
          dataStewardGroup: dataStewardGroup,
          dataStewardIDs: dataStewardIDs,
          connection: connection,
          endpoint: dataSourceFormData.winPath.fieldValue,
          spokeName: dataSourceFormData.spoke.fieldValue
        },
      });
    }

    if (connection === constants.CONNECTION_TYPES.azure) {
      const selectedTable = [dataSourceFormData.name.fieldValue];
      navigate("/ConfigureTables", {
        state: {
          selectedTables: selectedTable,
          selectedSchema: null,
          dataSourceData: dataSourceFormData,
          accessControlGroup: accessControlGroup,
          dataStewardGroup: dataStewardGroup,
          dataStewardIDs: dataStewardIDs,
          connection: connection,
          endpoint: dataSourceFormData.accountName.fieldValue,
          spokeName: dataSourceFormData.spoke.fieldValue
        },
      });
    }
  };

  return (
    <>
      <Formik initialValues={{}} onSubmit={() => { }}>
        <div>
          <Back />
          <h1 style={{ textAlign: "left" }}>{mode} Data Source</h1>
          <Form>
            {/* adding skeleton screen on loading */}
            {(formMode === constants.MODE.view ||
              formMode === constants.MODE.edit) &&
              loadingDataSource ? (
              <Box>
                <Grid container spacing={4}>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={4}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={4}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={4}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={12}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                  <Grid item xs={6}>
                    <Skeleton animation="wave" height={60} />
                  </Grid>
                </Grid>
              </Box>
            ) : (
              <>
                <Grid container spacing={4}>
                  <Grid item xs={5}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <DataField id="bf2dda1d-4d17-48c2-b464-a4357f86693a"
                        label="Name"
                        name="name"
                        required={true}
                        value={dataSourceFormData.name.fieldValue}
                        readOnly={
                          formMode === constants.MODE.view ? true : false
                        }
                        onChange={handleChange}
                        error={dataSourceFormData.name.isError}
                        disabled={
                          formMode === constants.MODE.view ||
                            formMode === constants.MODE.edit
                            ? true
                            : false
                        }
                        infoText="The created data source's name will be prefixed by 'UDL', (eg. UDLDataSourceName)"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={7}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <DataField id="f99710b0-1d05-4396-b930-79df2bdc4efc"
                        type="textarea"
                        name="description"
                        label="Description"
                        required={true}
                        multiline={true}
                        readOnly={
                          formMode === constants.MODE.view ? true : false
                        }
                        rows={formMode === constants.MODE.view ? 1 : 5}
                        value={dataSourceFormData.description.fieldValue}
                        onChange={handleChange}
                        error={dataSourceFormData.description.isError}
                        disabled={
                          formMode === constants.MODE.view ? true : false
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    {formMode !== constants.MODE.view && (
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <Autocomplete
                          options={idpUsersProduction}
                          onChange={(event, value) => {
                            let v = value as IUser;
                            dataSourceFormData.owner.fieldValue =
                              v === null ? "" : v.userName;
                            setOwnerValue(v === null ? "" : v.userName);
                            if (ownerValue !== "")
                              dataSourceFormData.owner.isError = false;
                          }}
                          getOptionLabel={(option) =>
                            option === undefined ? " " : option.userName
                          }
                          isOptionEqualToValue={(option, value) =>
                            option.userName === value.userName
                          }
                          value={functions.getIUser(
                            dataSourceFormData.owner.fieldValue
                          )}
                          disabled={
                            formMode === constants.MODE.view ? true : false
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="Owner"
                              label="Owner"
                              required
                              value={dataSourceFormData.owner.fieldValue}
                              error={dataSourceFormData.owner.isError}
                            />
                          )}
                        />
                      </FormControl>
                    )}

                    {formMode === constants.MODE.view && (
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="d50c771e-d275-4853-853b-a2b99ffc1411"
                          label="Owner"
                          name="owner"
                          readOnly={
                            formMode === constants.MODE.view ? true : false
                          }
                          value={dataSourceFormData.owner.fieldValue}
                          disabled={true}
                        />
                      </FormControl>
                    )}
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      {formMode !== constants.MODE.view && (
                        <Box>
                          <InputLabel htmlFor="accessControls">
                            Access Controls
                          </InputLabel>
                          <Select
                            name="accessControls"
                            label="accessControls"
                            multiple
                            value={accessControlGroup.map(value => value.toLowerCase())}
                            onChange={(event) => {
                              let v = event.target.value as string[];
                              setAccessControlGroup(v);
                            }}
                            labelId="accessControls"
                            fullWidth
                            disabled={
                              formMode === constants.MODE.view ? true : false
                            }
                            sx={{ textAlign: "left" }}
                          >
                            {accessControls.map(
                              (
                                item: IAccessControl,
                                index: number,
                                items: IAccessControl[]
                              ) => {
                                return (
                                  <MenuItem key={index} value={item.groupName.toLowerCase()}>
                                    {item.groupName}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                        </Box>
                      )}

                      {formMode === constants.MODE.view && (
                        <DataField id="0bcfb10a-de4c-45e0-8100-53079b5fdd75"
                          label="Access Controls"
                          name="accessControls"
                          value={dataSourceFormData.accessControls.fieldValue}
                          disabled={true}
                          readOnly={
                            formMode === constants.MODE.view ? true : false
                          }
                          type="textarea"
                          multiline={true}
                          rows={formMode === constants.MODE.view ? 1 : 5}
                        />
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <InputLabel htmlFor="securityClassification">
                        Security Classification
                      </InputLabel>
                      <Select
                        id="securityClassification"
                        name="securityClassification"
                        label="securityClassification"
                        value={
                          dataSourceFormData.securityClassification.fieldValue
                        }
                        variant={formMode === "View" ? "standard" : "outlined"}
                        // input={<OutlinedInput />}
                        onChange={updateDropdown}
                        sx={{ textAlign: "left" }}
                        disabled={
                          formMode === constants.MODE.view ? true : false
                        }
                        fullWidth
                      >
                        <MenuItem key={0} value={constants.SECURITY_CLASS_VALUES.general}>
                          {constants.SECURITY_CLASS.general}
                        </MenuItem>
                        <MenuItem key={1} value={constants.SECURITY_CLASS_VALUES.confidential}>
                          {constants.SECURITY_CLASS.confidential}
                        </MenuItem>
                        <MenuItem key={2} value={constants.SECURITY_CLASS_VALUES.highlyConfidential}>
                          {constants.SECURITY_CLASS.highlyConfidential}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <InputLabel htmlFor="privacyClassification">
                        Privacy Classification
                      </InputLabel>
                      <Select
                        id="privacyClassification"
                        name="privacyClassification"
                        label="privacyClassification"
                        value={
                          dataSourceFormData.privacyClassification.fieldValue
                        }
                        // input={<OutlinedInput />}
                        variant={formMode === "View" ? "standard" : "outlined"}
                        onChange={updateDropdown}
                        sx={{ textAlign: "left" }}
                        disabled={
                          formMode === constants.MODE.view ? true : false
                        }
                        fullWidth
                      >
                        <MenuItem key={0} value={constants.PRIVACY_CLASS_VALUES.none}>
                          {constants.PRIVACY_CLASS.none}
                        </MenuItem>
                        {disablePrivacy && (
                          <MenuItem key={1} value={constants.PRIVACY_CLASS_VALUES.personal}>
                            {constants.PRIVACY_CLASS.personal}
                          </MenuItem>
                        )}
                        {disablePrivacy && (
                          <MenuItem key={2} value={constants.PRIVACY_CLASS_VALUES.sensitive}>
                            {constants.PRIVACY_CLASS.sensitive}
                          </MenuItem>
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  {formMode !== constants.MODE.view && (
                    <Grid item xs={3}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                        error={showGroupError}
                      >
                        <Box>
                          <InputLabel htmlFor="dataStewardsAD">
                            Data Stewards Group *
                          </InputLabel>
                          <Select
                            name="dataStewardsAD"
                            onChange={updateDataStewardGroup}
                            labelId="dataStewardsAD"
                            label="dataStewardsAD"
                            fullWidth
                            displayEmpty
                            value={dataStewardGroup.toLowerCase()}
                            hidden={
                              formMode === constants.MODE.view ? true : false
                            }
                            sx={{ textAlign: "left" }}
                          >
                            {accessControls.map(
                              (
                                item: IAccessControl,
                                index: number,
                                items: IAccessControl[]
                              ) => {
                                return (
                                  <MenuItem key={index} value={item.groupName.toLowerCase()}>
                                    {item.groupName}
                                  </MenuItem>
                                );
                              }
                            )}
                          </Select>
                          <FormHelperText>
                            {/* First select Data Stewards group then search for Data
                          Stewards */}
                            <span style={{ color: "#d32f2f" }}>
                              {showGroupError ? "Field is required" : ""}
                            </span>
                            {stewardDataPending ? 'Loading...' : ''}
                          </FormHelperText>
                        </Box>
                      </FormControl>
                    </Grid>
                  )}
                  {formMode !== constants.MODE.view ? (
                    <Grid item xs={8}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        {dataStewardGroup && formMode === constants.MODE.add && !stewardDataPending ?
                          <Autocomplete
                            multiple
                            options={stewardData}
                            onChange={(event, value) => {
                              let v = value as IUser[];
                              setDataStewardIDs(v);
                              // if (v) {
                              //   dataSourceFormData.dataStewards.isError =
                              //     v.length === 0 ? true : false;
                              // } else {
                              //   dataSourceFormData.dataStewards.isError = true;
                              // }
                            }}
                            getOptionLabel={(option) =>
                              option === undefined ? "" : option.userName
                            }
                            // isOptionEqualToValue={(option, value) =>
                            //   option.userName === value.userName
                            // }
                            disabled={
                              formMode === constants.MODE.view ? true : false
                            }
                            value={dataStewardIDs}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="Data Stewards"
                                label="Data Stewards*"
                                value={dataStewardIDs}
                              // error={dataSourceFormData.dataStewards.isError}
                              // helperText={
                              //   dataSourceFormData.dataStewards.isError
                              //     ? "Field is required"
                              //     : ""
                              // }
                              />
                            )}
                          /> : ''}

                        {formMode === constants.MODE.edit ?
                          <Autocomplete
                            multiple
                            options={stewardData}
                            onChange={(event, value) => {
                              let v = value as IUser[];
                              setDataStewardIDs(v);
                              // if (v) {
                              //   dataSourceFormData.dataStewards.isError =
                              //     v.length === 0 ? true : false;
                              // } else {
                              //   dataSourceFormData.dataStewards.isError = true;
                              // }
                            }}
                            getOptionLabel={(option) =>
                              option === undefined ? "" : option.userName
                            }
                            // isOptionEqualToValue={(option, value) =>
                            //   option.userName === value.userName
                            // }
                            disabled={
                              formMode === constants.MODE.view ? true : false
                            }
                            value={dataStewardIDs}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="Data Stewards"
                                label="Data Stewards*"
                                value={dataStewardIDs}
                              // error={dataSourceFormData.dataStewards.isError}
                              // helperText={
                              //   dataSourceFormData.dataStewards.isError
                              //     ? "Field is required"
                              //     : ""
                              // }
                              />
                            )}
                          /> : ''}
                        <FormHelperText>
                          Select the AD Group first, to fetch relevant user IDs
                        </FormHelperText>
                      </FormControl>
                    </Grid>
                  ) : (
                    ""
                  )}
                  {formMode === constants.MODE.view && (
                    <Grid item xs={7}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="180b7a08-9351-4819-8777-87e2a7c33f17"
                          label="Data Stewards"
                          name="dataStewards"
                          value={dataSourceFormData.dataStewards.fieldValue}
                          disabled={true}
                          type="textarea"
                          multiline={true}
                          readOnly={
                            formMode === constants.MODE.view ? true : false
                          }
                          rows={formMode === constants.MODE.view ? 1 : 5}
                        />
                      </FormControl>
                    </Grid>
                  )}

                  <Grid item xs={4}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <InputLabel htmlFor="rttmsCi">&nbsp;</InputLabel>
                      <DataField id="2002ae78-0c2e-4496-9944-16d451a32356"
                        label="RTTMS CI"
                        name="rttmsCi"
                        type="text"
                        readOnly={
                          formMode === constants.MODE.view ? true : false
                        }
                        value={dataSourceFormData.rttmsCi.fieldValue}
                        onChange={handleChange}
                        disabled={
                          formMode === constants.MODE.view ? true : false
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <FormControl
                      sx={{ m: 1 }}
                      fullWidth
                      variant={
                        mode === constants.MODE.view ? "standard" : "outlined"
                      }
                    >
                      <Picker
                        label="Connection Type"
                        name="connectionType"
                        readOnly={
                          formMode === constants.MODE.view ? true : false
                        }
                        options={[
                          constants.CONNECTION_TYPES.foundry,
                          constants.CONNECTION_TYPES.mssql,
                          constants.CONNECTION_TYPES.oracle,
                          constants.CONNECTION_TYPES.postGres,
                          constants.CONNECTION_TYPES.s3Buckets,
                          constants.CONNECTION_TYPES.windowsFileshare,
                          constants.CONNECTION_TYPES.azure,
                        ]}
                        onChange={changeConnection}
                        value={connection}
                        disabled={
                          formMode === constants.MODE.add ? false : true
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={3}>
                    {formMode === constants.MODE.add && (
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <Autocomplete
                          options={
                            spokesData.length !== undefined
                              ? spokesData.map((x) => x.name)
                              : []
                          }
                          onChange={(event, value) => {
                            setSpokeType(value === null ? "" : value);
                            if (value !== null) {
                              dataSourceFormData.spoke.fieldValue =
                                spokesData!
                                  .find((x) => x.name === value)
                                  ?.spokeId.toString() ?? "";
                            }
                            if (value === null) {
                              dataSourceFormData.spoke.fieldValue = ""
                            }
                          }}
                          getOptionLabel={(option) =>
                            option === undefined ? " " : option
                          }
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          value={spokeType}
                          disabled={
                            formMode === constants.MODE.view ? true : false
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="Spokes"
                              label="Hub / Spoke"
                              value={dataSourceFormData.spoke.fieldValue}
                              error={dataSourceFormData.spoke.isError}
                            />
                          )}
                        />
                      </FormControl>
                    )}

                    {formMode !== constants.MODE.add && (
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          formMode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="3ce09b96-76d9-45d4-9567-08262dbdc4b6"
                          label="Hub / Spoke"
                          name="Spoke"
                          readOnly={
                            formMode !== constants.MODE.add ? true : false
                          }
                          value={dataSourceFormData.spoke.fieldValue}
                          disabled={
                            formMode === constants.MODE.view ? true : false
                          }
                        />
                      </FormControl>
                    )}
                  </Grid>
                  {formMode !== constants.MODE.add && adlsPathPrefix !== "" && connection === constants.CONNECTION_TYPES.azure &&
                    <Grid item xs={3}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          formMode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="3ce09b96-76d9-45d4-9567-08262dbdc4b6"
                          label="Path Prefix"
                          name="pathPrefix"
                          readOnly={true}
                          value={adlsPathPrefix}
                          disabled={true}
                        />
                      </FormControl>
                    </Grid>
                  }
                  {displaySaveBtn && (
                    <Grid item xs={6}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="73fb1c1b-bb90-4bfe-9d4f-2a237dcf621c"
                          label="Secret Name"
                          name="secretName"
                          required={true}
                          value={
                            formMode === constants.MODE.add
                              ? secretNameValue
                              : dataSourceFormData.secretName.fieldValue
                          }
                          onChange={handleChange}
                          readOnly={
                            formMode === constants.MODE.view ? true : false
                          }
                          infoText="The value of secret name will be auto-generated"
                          disabled={true}
                        />
                      </FormControl>
                    </Grid>
                  )}
                  {formMode === constants.MODE.view && (
                    <Grid item xs={6}>
                      <FormControl
                        sx={{ m: 1 }}
                        fullWidth
                        variant={
                          mode === constants.MODE.view ? "standard" : "outlined"
                        }
                      >
                        <DataField id="e3bccf07-5c1c-4cda-87d7-3110d41bcffd"
                          label="Secret Name"
                          name="secretName"
                          required={true}
                          value={
                            formMode === constants.MODE.add
                              ? secretNameValue
                              : dataSourceFormData.secretName.fieldValue
                          }
                          onChange={handleChange}
                          readOnly={
                            formMode === constants.MODE.view ? true : false
                          }
                          infoText="The value of secret name will be auto-generated"
                          disabled={true}
                        />
                      </FormControl>
                    </Grid>
                  )}
                  {/* Displaying connection details on view */}
                  {formMode === constants.MODE.view && (
                    <>
                      <Grid item xs={12}>
                        {/* <FormControl
                          sx={{ m: 1 }}
                          fullWidth
                          variant={
                            mode === constants.MODE.view ? "standard" : "outlined"
                          }
                        >
                          <DataField id="f7178b8f-3c44-4549-9026-07a00f7b8658"
                            label="Connection Details"
                            name="connectiondetails"
                            value={connectionDetailsValue}
                            readOnly={
                              formMode === constants.MODE.view ? true : false
                            }
                            disabled={true}
                          />
                        </FormControl> */}
                      </Grid>
                      {connection === "MSSQL" || connection === "Oracle" || connection === "Postgres" ?
                        <>
                          <Grid item xs={4}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="19d05cbf-7830-41d8-9e94-78951601f9c7"
                                label="Endpoint"
                                name="endpoint"
                                value={endpoint}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="88546686-3988-4155-8144-b29a76cdf4e7"
                                label="Database"
                                name="database"
                                value={database}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={2}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="9cc9c784-c567-4ede-8958-e7d5fedd67a2"
                                label="Port"
                                name="port"
                                value={port}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="616dc9d8-50d6-4297-8fa4-fb441120f7d3"
                                label="Username"
                                name="username"
                                value={username}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                        </>
                        : ""}
                      {connection === "S3 Buckets" ?
                        <>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="0dc0dbe2-cb1e-480d-924b-a7ddf5c54dd4"
                                label="Bucket"
                                name="bucket"
                                value={bucket}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="e3842cd4-5164-4483-8000-1c3e9b8c7f3a"
                                label="Path"
                                name="path"
                                value={path}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                        </>
                        : ""}
                      {connection === "Windows Fileshare" ?
                        <>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="85d8d84b-67b2-472a-a1a4-0473433a2e49"
                                label="Share Name"
                                name="shareName"
                                value={shareName}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="c5134d45-dcaa-48d8-a6bf-bfd1ad956aaf"
                                label="Username"
                                name="username"
                                value={username}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={3}>
                            <FormControl
                              sx={{ m: 1 }}
                              fullWidth
                              variant={
                                mode === constants.MODE.view ? "standard" : "outlined"
                              }
                            >
                              <DataField id="6ad8e228-c7dc-4ecd-8153-9914bb2fb7e2"
                                label="Path"
                                name="path"
                                value={path}
                                readOnly={
                                  formMode === constants.MODE.view ? true : false
                                }
                                disabled={true}
                              />
                            </FormControl>
                          </Grid>
                        </>
                        : ""}
                      {connection === constants.CONNECTION_TYPES.foundry ? <>
                        <Grid item xs={3}>
                          <FormControl
                            sx={{ m: 1 }}
                            fullWidth
                            variant={
                              "standard"
                            }
                          >
                            <DataField id="85d8d84b-67b2-472a-a1a4-0473433a2e49"
                              label="Host name"
                              name="hostName"
                              value={hostName}
                              readOnly={true}
                              disabled={true}
                            />
                          </FormControl>
                        </Grid>
                      </> : <></>}

                    </>
                  )}

                  <Grid item xs={1}></Grid>
                  {formMode === constants.MODE.add && (
                    <Grid item xs={12}>
                      <Box display="flex">
                        <ConnectionFoundry
                          selectedConnection={connection}
                          hostName={dataSourceFormData.hostName}
                          accessToken={dataSourceFormData.accessToken}
                          onChange={handleChange}
                        />
                        <ConnectionS3Bucket
                          selectedConnection={connection}
                          onChange={handleChange}
                          s3Bucket={dataSourceFormData.s3Bucket}
                          s3Path={dataSourceFormData.s3Path}
                        />
                        <ConnectionWindowsFileshare
                          selectedConnection={connection}
                          onChange={handleChange}
                          shareName={dataSourceFormData.shareName}
                          winPath={dataSourceFormData.winPath}
                          winUsername={dataSourceFormData.winUsername}
                          winPassword={dataSourceFormData.winPassword}
                        />
                        <ConnectionDatabase
                          selectedConnection={connection}
                          onChange={handleChange}
                          endpoint={dataSourceFormData.endpoint}
                          database={dataSourceFormData.database}
                          extractSource={dataSourceFormData.extractSource}
                          port={dataSourceFormData.port}
                          instanceName={dataSourceFormData.instanceName}
                          username={dataSourceFormData.username}
                          password={dataSourceFormData.password}
                          serviceName={dataSourceFormData.serviceName}
                        />
                        <ConnectionAzure
                          selectedConnection={connection}
                          onChange={handleChange}
                          onDropdownChange={handleDropdownChange}
                          accountName={dataSourceFormData.accountName}
                          container={dataSourceFormData.container}
                          pathPrefix={dataSourceFormData.name}
                          sasToken={dataSourceFormData.sasToken}
                          accountKey={dataSourceFormData.accountKey}
                        />
                      </Box>
                    </Grid>
                  )}
                  <Grid item xs={12}>
                    <Box display="flex" justifyContent="flex-end" m={2}>
                      {mode === constants.MODE.view && (
                        <Button id="9b4d2174-814f-4cf3-ba96-2c441291867d"
                          color="primary"
                          variant="contained"
                          onClick={viewExtractors}
                          style={{ marginRight: "1em" }}
                        >
                          View Extractors
                        </Button>
                      )}
                      {mode !== constants.MODE.view && (
                        <Button id="63eb0ee6-4803-44fd-8674-2cd21b587255"
                          color="primary"
                          variant="contained"
                          onClick={goBack}
                          style={{ marginRight: "1em" }}
                        >
                          Cancel
                        </Button>
                      )}

                      {displayTestBtn &&
                        (postConnectionPending && loadIcon ? (
                          <LoadingButton
                            loading
                            variant="outlined"
                            size="small"
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                          >
                            Processing
                          </LoadingButton>
                        ) : (
                          <Button id="f1171d9b-7c76-4fb6-9a11-f6fde4da50e4"
                            color="primary"
                            variant="contained"
                            onClick={testConnection}
                            style={{ marginRight: "1em" }}
                          >
                            Test Connection
                          </Button>
                        ))}

                      {displayEditBtn && (
                        <Button id="938eaf0f-723d-4e97-b4ed-cfd8af8f929c"
                          color="primary"
                          variant="contained"
                          onClick={editSource}
                          style={{ marginRight: "1em" }}
                        >
                          Edit
                        </Button>
                      )}
                      {displaySaveBtn &&
                        mode !== constants.MODE.view &&
                        (postDataSourcePending && loadIcon ? (
                          <LoadingButton
                            loading
                            variant="outlined"
                            size="small"
                            loadingPosition="start"
                            startIcon={<SaveIcon />}
                          >
                            Processing
                          </LoadingButton>
                        ) : (
                          <Button id="a39e419e-54a3-4898-ab1b-4435af278c6c"
                            color="primary"
                            variant="contained"
                            disabled={mode === constants.MODE.add}
                            onClick={createNewDataSource}
                            style={{ marginRight: "1em" }}
                          >
                            Save
                          </Button>
                        ))}
                      {displaySchemaBtn &&
                        mode !== constants.MODE.view &&
                        isAdmin === true && (
                          <SchemaSelection
                            dataSourceData={dataSourceFormData}
                            accessControlGroup={accessControlGroup}
                            dataStewardGroup={dataStewardGroup}
                            dataStewardIDs={dataStewardIDs}
                            spokeName={dataSourceFormData.spoke.fieldValue}
                            endpoint={dataSourceFormData.endpoint.fieldValue}
                            mode="Add"
                          />
                        )}
                      {
                        displayFoundrySelection &&
                        isAdmin === true && (
                          <FoundrySelection
                            dataSourceData={dataSourceFormData}
                            accessControlGroup={accessControlGroup}
                            dataStewardGroup={dataStewardGroup}
                            dataStewardIDs={dataStewardIDs}
                            spokeName={dataSourceFormData.spoke.fieldValue}
                            endpoint={hostName.replace('https://', '')}
                            mode="Add"
                          />
                        )
                      }
                      {/* Create extractor for an existing source - only if mode is view and layer type is not S3 */}
                      {displaySchemaBtn &&
                        mode === constants.MODE.view
                        && checkAdmin() &&
                        getDataSource?.layerType !==
                        constants.EXTRACT_TYPES.adls &&
                        getDataSource?.layerType !==
                        constants.EXTRACT_TYPES.s3Buckets &&
                        getDataSource?.layerType !==
                        constants.EXTRACT_TYPES.windowsFileshare && (
                          <SchemaSelection
                            dataSourceData={dataSourceFormData}
                            accessControlGroup={accessControlGroup}
                            dataStewardGroup={dataStewardGroup}
                            dataStewardIDs={dataStewardIDs}
                            endpoint={dataSourceFormData.endpoint.fieldValue}
                            sourceID={sourceId}
                            spokeName={dataSourceFormData.spoke.fieldValue}
                            mode="View"
                          />
                        )}
                      {displayExtractorBtn && checkAdmin() && (
                        <Button id="31eb2035-ca71-4619-b55e-fc451267248d"
                          color="primary"
                          variant="contained"
                          onClick={configureTables}
                          style={{ marginRight: "1em" }}
                        >
                          Create Extractors
                        </Button>
                      )}


                      {displayCustomSQLBtn && checkAdmin() && (
                        <Button id="909f9f73-7c7c-43d8-9f3c-30831219c071"
                          color="primary"
                          variant="contained"
                          onClick={configureTables}
                          style={{ marginRight: "1em" }}
                        >
                          Create Custom SQL Extractor
                        </Button>
                      )}
                    </Box>
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  {mode === "View" ? (
                    <>
                      <Grid item xs={6}>
                        <Box display="flex" justifyContent="flex-start">
                          <br />
                          Last Updated By: {lastUpdatedBy}
                        </Box>
                        <Box display="flex" justifyContent="flex-start">
                          Last Updated On: {lastUpdatedOn}
                        </Box>
                      </Grid>
                      <Grid item xs={6}>
                        <Box display="flex" justifyContent="flex-end">
                          <br />
                          Created By: {createdBy}
                        </Box>
                        <Box display="flex" justifyContent="flex-end">
                          Created On: {createdOn}
                        </Box>
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              </>
            )}
          </Form>
        </div>
      </Formik>
    </>
  );
};

export default DataSourceForm;
